/**------------- Cookie Consent Banner constants -------------**/

/*  General  */
export const COOKIE_EXPIRATION_DATE = 30;

/*  Banner  */
export const COOKIE_CONSENT_BANNER_LOCATION = "bottom";
export const COOKIE_CONSENT_BANNER_DESCRIPTION =
	'Questo sito utilizza i cookie. Cliccando su "Accetta", acconsenti all\'uso dei cookie. Cliccando su "Rifiuta", rifiuti l\'uso dei cookie. Per maggiori informazioni consulta la nostra ';

/*  Buttons  */
export const COOKIE_CONSENT_BANNER_ACCEPT_BUTTON_TEXT =
	"Accetta cookie di terze parti";
export const COOKIE_CONSENT_BANNER_DECLINE_BUTTON_TEXT =
	"Rifiuta cookie di terze parti";
